var translationKey = 'faqs.description';
var onepaywalmart = {
    drawerActionButton: {
        text: 'drawerActionButton.onepaywalmartDrawerActionButtonText',
        link: 'https://www.onepay.com/rewards'
    },
    certificateBalance: false,
    certificateExpirationDays: null,
    certificateValue: null,
    disclaimerTranslationKey: null,
    es: {
        termsAndConditionsLink: 'https://www.onepay.com/legal/onepay-rewards-terms'
    },
    en: {
        termsAndConditionsLink: 'https://www.onepay.com/legal/onepay-rewards-terms'
    },
    howToEarnPointsHeader: '',
    faqsSnapshot: true,
    isRewardTiers: false,
    isValuePropBanner: false,
    links: [],
    translationViewPrintKey: null,
    PRIVATE_LABEL: {
        actionButton: null,
        banner: 'onepaywalmart-plcc-banner.png',
        bannerSm: 'onepaywalmart-plcc-banner-sm.png',
        cashRewardsBalance: false,
        certificateHistoryImg: '',
        certificateHistory: false,
        earnings: {
            icons: {},
            titleKey: ''
        },
        faqs: null,
        rewardsBalance: false,
        snapshotTranslationKey: translationKey,
        translationKey: translationKey,
        valuePropImg: '',
        en: {
            propositions: []
        },
        es: {
            propositions: []
        }
    },
    DUAL_CARD: {
        actionButton: null,
        banner: 'onepaywalmart-dc-banner.png',
        bannerSm: 'onepaywalmart-dc-banner-sm.png',
        cashRewardsBalance: false,
        certificateHistoryImg: '',
        certificateHistory: false,
        earnings: {
            icons: {},
            titleKey: ''
        },
        faqs: null,
        rewardsBalance: false,
        snapshotTranslationKey: translationKey,
        translationKey: translationKey,
        valuePropImg: '',
        en: {
            propositions: []
        },
        es: {
            propositions: []
        }
    }
};
export default onepaywalmart;
